// import ReactPlayer from "react-player";
// import { Card, Container } from "react-bootstrap";

// export const OwnclothingvideoCard = ({ manufacturevideo }) => {
//   const hasVideo = manufacturevideo && manufacturevideo.length > 0;
//   const firstVideo = hasVideo ? manufacturevideo[0] : {};

//   return (
//     <Container className="owncloning-sec px-3">
//       <div className="row">
//         <div className="col-12 p-0 p-lg-2">
//           <div className="pb-5">
//             <Card
//               className="mt-5 own-video-card pb-2"
//               style={{ cursor: "pointer", paddingTop: "1px" }}
//             >
//               {firstVideo?.video_url && (
//                 <div
//                   className="border-danger"
//                   style={{ overflow: "hidden", aspectRatio: "14/8" }}
//                 >
//                   <ReactPlayer
//                     url={firstVideo.video_url}
//                     controls
//                     className="rounded-4"
//                     width="100%"
//                     height="100%"
//                   />
//                 </div>
//               )}
//               <h3 className="d-flex align-items-center justify-content-center text-center text-light mt-3 own-text px-5">
//                 {firstVideo.heading || "No heading available"}
//               </h3>
//             </Card>
//           </div>
//         </div>
//       </div>
//     </Container>
//   );
// };


import React, { useEffect, useRef, useState, Suspense, lazy } from "react";
import { Card, Container } from "react-bootstrap";

const LazyReactPlayer = lazy(() => import("react-player"));

export const OwnclothingvideoCard = ({ manufacturevideo }) => {
  const hasVideo = manufacturevideo && manufacturevideo.length > 0;
  const firstVideo = hasVideo ? manufacturevideo[0] : {};
  const [isVisible, setIsVisible] = useState(false);
  const playerRef = useRef(null);

  // IntersectionObserver to detect visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // load only once
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.25, // load when 25% in view
      }
    );

    if (playerRef.current) {
      observer.observe(playerRef.current);
    }

    return () => {
      if (playerRef.current) {
        observer.unobserve(playerRef.current);
      }
    };
  }, []);

  return (
    <Container className="owncloning-sec px-3">
      <div className="row">
        <div className="col-12 p-0 p-lg-2">
          <div className="pb-5">
            <Card className="mt-5 own-video-card pb-2" style={{ cursor: "pointer", paddingTop: "1px" }}>
              <div
                className="border-danger"
                style={{ overflow: "hidden", aspectRatio: "14/8" }}
                ref={playerRef}
              >
                {isVisible ? (
                  <Suspense fallback={<div style={{ height: "100%", background: "#000" }}></div>}>
                    <LazyReactPlayer
                      url={firstVideo.video_url}
                      controls
                      className="rounded-4"
                      width="100%"
                      height="100%"
                    />
                  </Suspense>
                ) : (
                  <div style={{ height: "100%", backgroundColor: "#000" }} />
                )}
              </div>
              <div className="h3 d-flex align-items-center justify-content-center text-center text-light mt-3 own-text px-5">
                {firstVideo.heading || "No heading available"}
              </div>
            </Card>
          </div>
        </div>
      </div>
    </Container>
  );
};
